/** Copy for the Discount codes screens (ui-spec §1.1). Sentence case. */
export const CODES_COPY = {
  navLabel: "Discount codes",
  listTitle: "Discount codes",
  listSubtitleBase: "Create codes for your events and share them anywhere.",
  listSubtitleCapOn: (cap) =>
    `Members keep their membership discount on top, up to ${cap}% in total.`,
  listSubtitleCapOff: "Members keep their membership discount on top.",
  listAppNote:
    "Customers can use codes on the latest ShoUp app and on the website.",
  cta: "Create discount code",

  tileBookings: "Bookings with a code (30 days)",
  tileRevenue: "Revenue from those bookings",
  tileDiscount: "Discount given by codes",

  searchPlaceholder: "Search codes…",
  statusPlaceholder: "Select status",
  eventPlaceholder: "Select event",
  communityPlaceholder: "Select community",

  cancelledTooltip: "Switched off by ShoUp.",
  cancelledDetail:
    "Switched off by ShoUp. Contact ShoUp support if you think this is a mistake.",
  switchedOffTag: "Switched off by ShoUp",
  switchedOffDetail: "Switched off by ShoUp. Contact ShoUp to bring it back.",
  noUpcomingEvents: "No upcoming events",

  copiedTitle: "Code copied",
  copiedMessage: (code) =>
    `${code} copied. Share it anywhere: WhatsApp, Instagram, posters.`,

  emptyTitle: "No discount codes yet",
  emptyBody: "Create a code for your events and share it anywhere.",
  emptyFilteredTitle: "No codes found",
  emptyFilteredBody: "Try adjusting your filters.",

  formTitleCreate: "Create discount code",
  formTitleEdit: "Edit discount code",
  formSubtitle: 'People type it at checkout under "Have a code?"',
  sectionCode: "Code",
  sectionAudience: "Who can use it",
  sectionEvents: "Events",
  sectionLimits: "Limits",
  sectionDates: "Dates",
  sectionNotes: "Notes",

  fieldCommunity: "Community",
  fieldCommunityExtra: "A code works on events of one community.",
  fieldCommunityRequired: "Please select a community",
  fieldName: "Code name",
  fieldNamePlaceholder: "e.g. RUNFEST15",
  fieldNameExtra: "Letters and numbers, 4–20 characters",
  fieldNameRequired: "Please enter a code name",
  fieldNameFormat: "Use 4–20 letters and numbers, with no spaces or symbols",
  fieldNameTaken: (code) =>
    `You already have a live code called ${code}. Pick another name.`,
  fieldNameReserved: "This name is reserved. Pick another name.",
  fieldDiscount: "Discount",
  fieldPercent: "Percent off",
  fieldPercentErr: "Enter a percentage from 1 to 100",
  fieldMaxPerTicket: "Maximum per ticket (optional)",
  fieldMaxPerTicketPlaceholder: "No limit",
  fieldMaxPerTicketExtra: 'For example "up to ₹300"',
  fieldFlat: "Amount off per ticket",
  fieldFlatErr: "Enter an amount of at least ₹1",
  fieldAudience: "Who can use it",
  audienceEveryone: "Everyone",
  audienceMembersOf: (community) =>
    community ? `Members of ${community}` : "Members",
  audienceNonMembersOnly: "Non-members only",
  audienceMembersExtra: (community) =>
    `Anyone with an active membership in ${community || "your community"}, free tier included, when they pay.`,
  audienceNonMembersExtra: (community) =>
    `Anyone without an active membership in ${community || "your community"}. Expired or cancelled members count as non-members.`,
  audienceDisabled: "Set up memberships to use this",
  fieldKeepMembership: "Members also keep their membership discount",
  keepMembershipExtraCapOn: (cap) =>
    `On: membership and code add up, up to ${cap}% in total. Off: members get whichever is higher.`,
  keepMembershipExtraCapOff:
    "On: membership and code add up. Off: members get whichever is higher.",
  keepMembershipTooltip:
    "A code on its own can go above the cap, so a 100% code always works.",
  fieldEvents: "Events",
  fieldEventsPlaceholder: "Search your events",
  eventPast: "Past",
  eventOtherCommunity: "In another community",
  fieldEventsExtra: "The code covers every ticket type of these events.",
  fieldEventsErr: "Please select at least one event",
  fieldTotalUses: "Total uses",
  fieldTotalUsesPlaceholder: "No limit",
  fieldPerPerson: "Uses per person",
  fieldPerPersonExtra: "One order is one use",
  fieldPerPersonErr: "Please enter the uses per person",
  fieldLimitsCount: "Limits count",
  limitsPerEvent: "Per event",
  limitsAcrossAll: "Across all events",
  fieldTicketsPerOrder: "Discounted tickets per order",
  fieldTicketsPerOrderPlaceholder: "All",
  fieldTicketsPerOrderExtra:
    "The highest-priced tickets get the discount first.",
  fieldStarts: "Starts",
  fieldStartsExtra: "Leave empty to start now",
  fieldExpires: "Expires",
  fieldExpiresExtra:
    "Times are in IST. Defaults to 11:59 pm on the day you pick. The code can stay live after its events are over.",
  fieldExpiresErr: "Please pick an expiry date",
  fieldExpiresBeforeStart: "Expiry must be after the start",
  fieldCanCombine: "Can be combined",
  fieldCanCombineExtra:
    "Lets customers use this code together with other codes on one booking.",
  fieldNote: "Private note (optional)",
  fieldNotePlaceholder: "e.g. Partner: RunFest",
  fieldNoteExtra: "Only you, your team and ShoUp see this. Customers never do.",
  formFooter:
    "The discount comes out of your ticket revenue. You can change anything later; changes apply to new bookings only, and every change is saved in the code's history.",
  btnCancel: "Cancel",
  btnReview: "Review",
  btnBack: "Back",
  btnCreate: "Create code",
  btnSave: "Save changes",
  reviewTitle: "Check your code",
  reviewKeepMembership: "Members keep membership discount",
  reviewStartsNow: "Now",
  editNotice:
    "Changes apply to new bookings only. People already paying keep their price, and every booking keeps the deal it got.",
  toastCreatedTitle: "Code created",
  toastCreatedMessage: (code) =>
    `${code} is ready. Copy it and share it anywhere. It can take up to a minute to show at checkout.`,
  toastUpdatedTitle: "Code updated",
  toastUpdatedMessage: "Changes apply to new bookings only.",

  detailBack: "Back to Discount codes",
  tileUses: "Uses",
  tileTicketsSold: "Tickets sold with it",
  tileRevenueDetail: "Revenue",
  tileCodeDiscount: "Code discount given",
  tabRedemptions: "Redemptions",
  tabHistory: "Change history",
  membershipNone: "Not a member",
  redemptionsEmpty: "No one has used this code yet.",
  historyEmpty: "No changes since this code was created.",
  historyShoupTeam: "ShoUp team",

  confirmEndTitle: "End this code now?",
  confirmEndContent: (code) =>
    `${code} stops working for new bookings straight away. Existing bookings keep their price. You can't restart this run, but you can use Run again later.`,
  confirmEndOk: "End now",
  confirmRunAgainTitle: (code) => `Run ${code} again?`,
  confirmRunAgainContent:
    "This ends the current run and starts a new one with the same name, fresh limits and separate results. Check the dates before you share it.",
  confirmRunAgainOk: "Run again",
  runAgainExpiresPast: "Expiry must be in the future",
  toastPaused: (code) =>
    `${code} paused. Customers can't use it until you resume it.`,
  toastResumed: (code) => `${code} is live again.`,
  toastEnded: (code) =>
    `${code} has ended. Existing bookings keep their price.`,
  toastRunAgain: (code) => `A new run of ${code} has started.`,

  actionEdit: "Edit",
  actionMore: "More",
  actionCopy: "Copy code",
  actionPause: "Pause",
  actionResume: "Resume",
  actionRunAgain: "Run again",
  actionEndNow: "End now",

  eventTab: "Discount codes",
  eventTabHeading: "Codes for this event",
  eventTabEmpty: "No codes cover this event yet.",

  settingsTab: "Discount codes",
  settingsHeading: "Discount codes",
  settingsText:
    "Members keep their membership discount on top of a code, up to a total cap. A code on its own can go above it.",
  settingsCap: "Total discount cap",
  settingsCapExtra: (max) =>
    `Up to ${max}%. Applies to all your communities. Changes apply to new bookings only.`,
  settingsCapErr: (max) => `Enter a cap from 1 to ${max}%`,
  settingsShoupCeiling: (max) => `ShoUp has set your maximum to ${max}%.`,
  settingsCapOff:
    "ShoUp has switched the cap off for your account, so membership and codes add up fully. Contact ShoUp support to change this.",
  settingsBtn: "Save changes",
  settingsToastTitle: "Cap updated",
  settingsToastMessage: "Changes apply to new bookings only.",
};
